import React from 'react';

export const Guide = () => {
  return (
    <>
      <img src="/static/service/guide.png" alt="service_guide"/>
    </>
  );
};